import axios from './dataSources/default';

// constants
import { config } from '../config';

// FAVOURITES


/**  get favourites for user by guid
 *
 * @param { string } userGuid users identifier guid
 *
 * @returns { Promise<Array<Object>> } list of favourite ranges or empty array
 */
export function getFavourites(userGuid) {
  const url = `${config.URLS.SOFOLOGY_REX}${userGuid}/catalog/my-favourites`;
  return axios.get(url).then(res => res.data).catch(() => []);
}


/**  add a range to a users favourites
 *
 * @param { string } userGuid users identifier guid
 * @param { string } name range name
 * @param { string } sku ranges item sku

 * @returns { Promise<Array<Object>> } list of favourite ranges or empty array
 */
export function favouriteRange(userGuid, name, sku) {
  const url = `${config.URLS.SOFOLOGY_REX}${userGuid}/my-favourites`;
  return axios.post(url, { name, sku }).then(res => res.data);
}

/**  remove a range from users favourites
 *
 * @param { string } userGuid users identifier guid
 * @param { string } name range name

 * @returns { Promise<Array<Object>> } list of favourite ranges or empty array
 */
export function unFavouriteRange(userGuid, name) {
  const url = `${config.URLS.SOFOLOGY_REX}${userGuid}/my-favourites/range/${name}`;
  return axios.delete(url).then(res => res.data);
}


// RECENTLY VIEWED


/**  get recently viewed for user by guid
 *
 * @param { string } userGuid users identifier guid
 *
 * @returns { Promise<Array<Object>> } list of recently viewed ranges or empty array
 */
export function getRecentlyViewed(userGuid) {
  const url = `${config.URLS.SOFOLOGY_REX}${userGuid}/catalog/recently-viewed?includeTrends=true`;
  return axios.get(url).then(res => res.data).catch(() => []);
}



// WEBPACK FOOTER //
// ./src/services/activityService.js